module.exports = __webpack_public_path__ + "media/img/user8-128x128-fb46f544.jpg";